import script from "./ImpostazioniEc.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpostazioniEc.vue?vue&type=script&setup=true&lang=js"

import "./ImpostazioniEc.vue?vue&type=style&index=0&id=12e6d310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12e6d310"]])

export default __exports__